import { render, staticRenderFns } from "./EditProductCategoryModal.vue?vue&type=template&id=3b603aba&"
import script from "./EditProductCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditProductCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports